// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
var tcpi_bytes_retransIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_bytes_retrans";
    }
};
var tcpi_bytes_sentIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_bytes_sent";
    }
};
var tcpi_data_segs_inIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_data_segs_in";
    }
};
var tcpi_data_segs_outIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_data_segs_out";
    }
};
var tcpi_dsack_dupsIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_dsack_dups";
    }
};
var tcpi_rcv_ooopackIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_rcv_ooopack";
    }
};
var tcpi_total_retransIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_total_retrans";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt);
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonInt));
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(tcpi_total_retransIsSymbol)())(tcpi_rcv_ooopackIsSymbol)())(tcpi_dsack_dupsIsSymbol)())(tcpi_data_segs_outIsSymbol)())(tcpi_data_segs_inIsSymbol)())(tcpi_bytes_sentIsSymbol)())(tcpi_bytes_retransIsSymbol)())());
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonInt));
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(tcpi_total_retransIsSymbol)()())(tcpi_rcv_ooopackIsSymbol)()())(tcpi_dsack_dupsIsSymbol)()())(tcpi_data_segs_outIsSymbol)()())(tcpi_data_segs_inIsSymbol)()())(tcpi_bytes_sentIsSymbol)()())(tcpi_bytes_retransIsSymbol)()())());
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var arbitraryRowListCons = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbMaybe(Test_QuickCheck_Arbitrary.arbInt));
var LinuxTcpInfo = function (x) {
    return x;
};
var showTcpInfo = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_bytes_retransIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_bytes_sentIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_data_segs_inIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_data_segs_outIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_dsack_dupsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tcpi_rcv_ooopackIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(tcpi_total_retransIsSymbol)(Data_Show.showInt))(showMaybe))(showMaybe))(showMaybe))(showMaybe))(showMaybe))(showMaybe));
var eqTcpInfo = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(tcpi_total_retransIsSymbol)(Data_Eq.eqInt))()(tcpi_rcv_ooopackIsSymbol)(eqMaybe))()(tcpi_dsack_dupsIsSymbol)(eqMaybe))()(tcpi_data_segs_outIsSymbol)(eqMaybe))()(tcpi_data_segs_inIsSymbol)(eqMaybe))()(tcpi_bytes_sentIsSymbol)(eqMaybe))()(tcpi_bytes_retransIsSymbol)(eqMaybe));
var encodeJsonTcpInfo = {
    encodeJson: function (v) {
        return encodeJson(v);
    }
};
var decodeJsonTcpInfo = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (linuxTcpInfo) {
            return pure(linuxTcpInfo);
        });
    }
};
var arbitraryTcpInfo = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRecordInstance()(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ arbitraryRowListCons(/* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitraryRowListCons(Test_QuickCheck_Arbitrary.arbInt)(Test_QuickCheck_Arbitrary.arbitraryRowListNil)()()()(tcpi_total_retransIsSymbol))()()()(tcpi_rcv_ooopackIsSymbol))()()()(tcpi_dsack_dupsIsSymbol))()()()(tcpi_data_segs_outIsSymbol))()()()(tcpi_data_segs_inIsSymbol))()()()(tcpi_bytes_sentIsSymbol))()()()(tcpi_bytes_retransIsSymbol));
var mkTransStats = function (v) {
    return {
        sent: new Data_Maybe.Just({
            lostPackets: v.tcpInfo.tcpi_total_retrans,
            totalPackets: v.tcpInfo.tcpi_data_segs_out,
            lostBytes: v.tcpInfo.tcpi_bytes_retrans,
            totalBytes: v.tcpInfo.tcpi_bytes_sent
        }),
        received: new Data_Maybe.Just({
            outOfOrder: v.tcpInfo.tcpi_rcv_ooopack,
            duplicate: v.tcpInfo.tcpi_dsack_dups,
            total: v.tcpInfo.tcpi_data_segs_in
        })
    };
};
var toTranmissionStatsResult = function (v) {
    return {
        startStats: mkTransStats(v.startStats),
        latestStats: mkTransStats(v.latestStats),
        kernelName: v.latestStats.kernelName,
        kernelVersion: v.latestStats.kernelVersion
    };
};
export {
    LinuxTcpInfo,
    mkTransStats,
    toTranmissionStatsResult,
    showTcpInfo,
    eqTcpInfo,
    arbitraryTcpInfo,
    decodeJsonTcpInfo,
    encodeJsonTcpInfo
};
//# sourceMappingURL=index.js.map
